import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface BillingCycleToggleProps {
  isYearly: boolean;
  onToggle: (isYearly: boolean) => void;
  savingsPercent?: number;
}

export default function BillingCycleToggle({
  isYearly,
  onToggle,
  savingsPercent = 25,
}: BillingCycleToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex rounded-full border border-border bg-muted p-[3px]">
      <button
        type="button"
        aria-pressed={!isYearly}
        onClick={() => onToggle(false)}
        className={cn(
          "rounded-full px-3.5 py-1.5 text-[12px] font-medium transition-all",
          !isYearly
            ? "bg-secondary font-semibold text-secondary-foreground"
            : "text-muted-foreground hover:text-foreground",
        )}
      >
        {t("subscription.monthly")}
      </button>
      <button
        type="button"
        aria-pressed={isYearly}
        onClick={() => onToggle(true)}
        className={cn(
          "flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[12px] font-medium transition-all",
          isYearly
            ? "bg-secondary font-semibold text-secondary-foreground"
            : "text-muted-foreground hover:text-foreground",
        )}
      >
        <span>{t("subscription.yearly")}</span>
        <span
          className={cn(
            "rounded-full px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-widest",
            isYearly
              ? "bg-secondary-foreground/20 text-secondary-foreground"
              : "bg-green-500/15 text-green-400",
          )}
        >
          {t("subscription.savePercent", { percent: savingsPercent })}
        </span>
      </button>
    </div>
  );
}
